import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";

export function PreviewPdfDialog({ url }: { url: string }) {
  return (
    <BaseDialog size="4xl" className="overflow-hidden p-0" bodyClassName="mt-0">
      <iframe src={url} width="100%" height="800px" title="pdf preview" />
    </BaseDialog>
  );
}
